import gql from 'graphql-tag';
import EXTERNAL_ID_FRAGMENT from 'graph/fragments/external-id';

const GET_ORGANIZATIONS_AND_ROLES = gql`
  query getOrganizationsAndRoles($rolesWhere: OrganizationRolesWhereInput) {
    organizations {
      id
      name
      externalId {
        ...BaseExternalId
      }
    }
    organizationRoles(where: $rolesWhere) {
      id
      name
      displayName
      public
    }
  }
  ${EXTERNAL_ID_FRAGMENT}
`;

export default GET_ORGANIZATIONS_AND_ROLES;
